import React, {useReducer} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import ContactInfo from 'app/components/club/ContactInfo';
import {useDispatch} from 'react-redux';
import {Helmet} from 'react-helmet-async';
import {TITLE_POSTFIX} from 'app/seo/seo.constants';
import {fetchClubContactDetail} from 'app/routes/club/ClubContactDetailPageActions';
import {ClubContactDetailPageReducer} from 'app/routes/club/ClubContactDetailPageReducer';
import {LoadingIndicator, LOADING_MESSAGE} from '@fupa/fupa-uikit';
import {useParams} from 'react-router';
import {useFetchData, useRestoreData} from 'app/hooks/dataHooks';
import {useSiteSpecificAdTargeting} from 'app/components/ads/useAdTargeting';

const ClubContactDetailPage = () => {
  const {restoredData} = useRestoreData('ClubContactDetailPage');
  const {contactSlug} = useParams();
  const initialState = restoredData ?? {
    isFetching: false,
    contact: {},
  };
  const [state, dispatch] = useReducer(ClubContactDetailPageReducer, initialState);
  const dispatchRedux = useDispatch();

  const loadData = () => fetchClubContactDetail(contactSlug, dispatchRedux)(dispatch, state);
  const {contact, isFetching} = state;
  useFetchData(state, loadData, 'ClubContactDetailPage');

  useSiteSpecificAdTargeting({club: contact.club?.slug}, [contact.club]);

  const title = `${contact.name} - ${contact.club?.name ?? ''} - Kontakt`;
  const meta = [
    {name: 'description', content: title},
    {
      name: 'robots',
      content: 'noindex, follow',
    },
  ];

  const content = isFetching ? (
    <LoadingIndicator message={LOADING_MESSAGE.loadingData} />
  ) : (
    <ContactInfo contact={contact} />
  );

  return (
    <ContentAdDesktop noTabs top='4.5rem'>
      <Helmet title={title + TITLE_POSTFIX} meta={meta} />
      {content}
    </ContentAdDesktop>
  );
};

export default ClubContactDetailPage;
